import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import { cn } from '@/lib/utils';

interface PlaylistProgressBarProps {
  currentEpisode: number;
  totalEpisodes: number;
  watchedEpisodes: Set<number>;
  theme: 'purple' | 'blue' | 'dark' | 'white';
  episodeName?: string;
}

const themeColors = {
  purple: 'bg-[#7A5CFF]',
  blue: 'bg-[#2D6CF6]',
  dark: 'bg-white',
  white: 'bg-[#7A5CFF]',
};

export const PlaylistProgressBar: React.FC<PlaylistProgressBarProps> = ({
  currentEpisode,
  totalEpisodes,
  watchedEpisodes,
  theme,
  episodeName
}) => {
  useLanguage();
  const progress = ((watchedEpisodes.size) / totalEpisodes) * 100;

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between text-sm">
        <span className="font-medium">
          {translateInterfaceText("Episódio")}{" "}{currentEpisode + 1} {" "}{translateInterfaceText("de")}{" "}{totalEpisodes}
          {episodeName && <span className="text-muted-foreground"> • {episodeName}</span>}
        </span>
        <span className="text-muted-foreground">{Math.round(progress)}%</span>
      </div>
      
      <div className="h-2 bg-muted rounded-full overflow-hidden">
        <div 
          className={cn(
            "h-full rounded-full transition-all duration-500",
            themeColors[theme]
          )}
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  );
};
